export default {
  // 數據統計
  totalData: "共計{count}條數據",

  // 加載
  loading: "拼命加載中",

  // 表格列
  currency: "幣種",
  balance: "餘額",

  // 空狀態
  noWalletData: "當前調證文件中未解析到錢包餘額數據",

  // 下載
  downloadDetails: "下載數據明細",
  downloadFileName: "數據明細",
};
